import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/FocusLayout.css';

const FocusLayout = ({ children }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-background-light dark:bg-background-dark min-h-screen">
      <main>
        {children}
      </main>
    </div>
  );
};

export default FocusLayout;
